import { render, staticRenderFns } from "./botonEditarMiPerfil.vue?vue&type=template&id=c47301d0&"
import script from "./botonEditarMiPerfil.vue?vue&type=script&lang=js&"
export * from "./botonEditarMiPerfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports